import { combineEpics } from "redux-observable"

import * as addFeedEpics from "./add-feed-epics"
import * as attachmentEpics from "./attachment-epics"
import * as authenticationEpics from "./authentication-epics"
import * as autocompleteEpics from "./autocomplete-epics"
import * as clusterEpics from "./cluster-epics"
import * as communityEpics from "./community-epics"
import * as communityParticipantEpics from "./community-participant-epics"
import * as dashboardEpics from "./dashboard-epics"
import * as dimensionEpics from "./dimension-epics"
import * as evidenceEpics from "./evidence-epics"
import * as feedEpics from "./feed-epics"
import * as insightAreaEpics from "./insight-area-epics"
import * as keyIssueEpics from "./key-issue-epics"
import * as knowledgeEpics from "./knowledge-epics"
import * as knowledgeDataEpics from "./knowledge-data-epics"
import * as messageEpics from "./message-epics"
import * as moderationEpics from "./moderation-feed-epics"
import * as notificationEpics from "./notification-epics"
import * as projectEpics from "./project-epics"
import * as reportEpics from "./report-epics"
import * as roleEpics from "./role-epics"
import * as sessionEpics from "./session-epics"
import * as sourceEpics from "./source-epics"
import * as stakeholderEpics from "./stakeholder-epics"
import * as studioBriefingEpics from "./studio-briefing-epics"
import * as studioCreateDimensionEpics from "./studio-create-dimension-epics"
import * as studioEditEpics from "./studio-edit-epics"
import * as studioEpics from "./studio-epics"
import * as studioImageEpics from "./studio-image-epics"
import * as topicEpics from "./topic-epics"
import * as userEpics from "./user-epics"

const treeOfEpics = [
    addFeedEpics,
    attachmentEpics,
    authenticationEpics,
    autocompleteEpics,
    clusterEpics,
    communityEpics,
    communityParticipantEpics,
    dashboardEpics,
    dimensionEpics,
    evidenceEpics,
    feedEpics,
    insightAreaEpics,
    keyIssueEpics,
    knowledgeEpics,
    knowledgeDataEpics,
    messageEpics,
    moderationEpics,
    notificationEpics,
    projectEpics,
    reportEpics,
    roleEpics,
    sessionEpics,
    sourceEpics,
    stakeholderEpics,
    studioBriefingEpics,
    studioCreateDimensionEpics,
    studioEditEpics,
    studioEpics,
    studioImageEpics,
    topicEpics,
    userEpics,
]

const epics = treeOfEpics.reduce(
    (previousEpicsList, epicObject) =>
        previousEpicsList.concat(
            Object.keys(epicObject).map((key) => epicObject[key])
        ),
    []
)

export default combineEpics(...epics)
